import React, { useEffect, useState } from 'react'

import { Button, Card, Form, Input } from 'antd'
import { connect } from 'react-redux'
import { faEdit, faPhone } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getTranslate } from 'react-localize-redux'

import IconButton from '../../antd/Buttons/IconButton'
import { validateFormInput } from '../../../utils'

import '../../../assets/student-extra-contact-details.scss'

const TITLE = 'Phone number'
const EMPTY_MESSAGE = 'None'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const PhoneNumberForm = ({ t, form, phoneNumber = '', onSubmit }) => {
  const [isInEditionMode, setIsInEditionMode] = useState(false)

  const { getFieldDecorator } = form

  /**
   * Drop what was typed but never saved when the edition mode is opened again
   */
  useEffect(() => {
    if (isInEditionMode) {
      form.setFieldsValue({ phoneNumber })
    }
  }, [isInEditionMode])

  const checkPhoneNumber = (rule, value, callback) => {
    if (!validateFormInput('phone', value)) {
      callback(t('Only numbers are authorized !'))
    }

    callback()
  }

  const handleSubmit = e => {
    e.preventDefault()

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values.phoneNumber)
        setIsInEditionMode(false)
      }
    })
  }

  return (
    <Card
      type='inner'
      title={[<FontAwesomeIcon key='title-icon' icon={faPhone} />, ' ', t(TITLE)]}
      extra={(<IconButton icon={faEdit} onClick={() => setIsInEditionMode(!isInEditionMode)} />)}
    >
      {!isInEditionMode && <span>{phoneNumber || t(EMPTY_MESSAGE)}</span>}
      {isInEditionMode && (
        <Form
          name='phoneNumberForm'
          className='student-extra-contact-details'
          onSubmit={handleSubmit}
        >
          <Form.Item>
            {getFieldDecorator('phoneNumber', { rules: [{ validator: checkPhoneNumber }], initialValue: phoneNumber })(
              <Input prefix={<FontAwesomeIcon icon={faPhone} />} placeholder={t('common.phone_number')} />
            )}
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit'>{t('Save')}</Button>
          </Form.Item>
        </Form>
      )}
    </Card>
  )
}

export default connect(mapStateToProps)(Form.create()(PhoneNumberForm))
